import { Box, useToken } from '@chakra-ui/react';

export function Ticket({
  code,
  backgroundColor = 'white',
  width = 348,
}: {
  code: string;
  backgroundColor?: string;
  width?: number;
}) {
  const [backgroundColorToken] = useToken('colors', [backgroundColor]);

  // Adjust viewBox and paths based on size
  const dimensions = {
    width,
    viewBox: `0 0 ${width} 70`,
  };

  return (
    <svg fill='none' height='100%' style={{ direction: 'ltr' }} viewBox={dimensions.viewBox} width='100%'>
      <g clipPath='url(#clip0_270_71)'>
        <g filter='url(#filter0_d_270_71)'>
          <path
            clipRule='evenodd'
            d={`M3 9a8 8 0 0 1 8-8h${dimensions.width - 22}a8 8 0 0 1 8 8v12c-6.627 0-12 5.373-12 12s5.373 12 12 12v12a8 8 0 0 1-8 8H11a8 8 0 0 1-8-8V44.834C8.675 43.882 13 38.946 13 33S8.675 22.118 3 21.166z`}
            fill={backgroundColorToken}
            fillRule='evenodd'
          />
        </g>
        <path
          clipRule='evenodd'
          d='m43.463 25.161 7.464-4.328v12.145c-.015 4.505 3.15 8.538 7.508 9.598l.103.03-.06.073c-.102.133-.19.25-.309.368-.397.398-.824.75-1.295 1.06s-.957.574-1.472.795a9 9 0 0 1-1.634.5 8 8 0 0 1-1.634.177h-.059a8.7 8.7 0 0 1-1.752-.177 8 8 0 0 1-1.634-.515 9 9 0 0 1-1.472-.795 8 8 0 0 1-1.28-1.06 8.7 8.7 0 0 1-1.06-1.28 9.5 9.5 0 0 1-.795-1.473 8.6 8.6 0 0 1-.501-1.619c-.118-.603-.132-1.222-.132-1.752V25.205zm18.77 15.31c.426-1.207.647-2.4.662-3.518V24.116l5.653-3.239v12.145a8.5 8.5 0 0 1-.147 1.546 7.45 7.45 0 0 1-1.178 2.738 7.82 7.82 0 0 1-2.09 2.076c-.413.28-.854.515-1.31.706a6.3 6.3 0 0 1-1.443.442c-.015 0-.044 0-.06.014l-.102.015zM41.21 23.983v12.881c-.015 5.962 4.843 10.835 10.85 10.85h.029c1.899 0 3.783-.5 5.417-1.443l7.935-4.534c3.283-1.693 5.343-5.035 5.343-8.715V19.567c0-.044-.014-.073-.058-.088l-1.944-1.134a.13.13 0 0 0-.103 0l-7.964 4.475c-.03.015-.059.06-.059.089v14.014c0 .589-.058 1.178-.176 1.752a8.6 8.6 0 0 1-.516 1.62c-.044.102-.088.19-.132.294l-.015.044h-.044a5 5 0 0 1-.456-.074l-.06-.014c-.5-.104-1.515-.383-2.723-1.163a8 8 0 0 1-1.148-.943 8 8 0 0 1-.942-1.148 7.5 7.5 0 0 1-.706-1.31 8 8 0 0 1-.442-1.443 6.7 6.7 0 0 1-.118-1.53v-13.44c0-.045-.015-.075-.059-.09l-1.943-1.177c-.015-.015-.044-.015-.059-.015s-.044 0-.059.015l-9.804 5.594c-.03.015-.044.059-.044.088'
          fill='#2015FF'
          fillRule='evenodd'
        ></path>
        <path d='M92 5v56' stroke='#3A3A3A' strokeDasharray='1 4' strokeLinejoin='round'></path>
        <path d={`M108 38h${dimensions.width - 138}`} id='pd-coupon-code' stroke={backgroundColorToken}></path>
        <text style={{ direction: 'inherit' }}>
          <Box
            as='textPath'
            dir='auto'
            fill='black'
            fontFamily='monospace'
            fontSize='md'
            fontWeight='500'
            href='#pd-coupon-code'
          >
            {code}
          </Box>
        </text>
      </g>
      <defs>
        <clipPath id='clip0_270_71'>
          <path d={`M0 0h${dimensions.width}v70H0z`} fill='#fff'></path>
        </clipPath>
        <filter
          colorInterpolationFilters='sRGB'
          filterUnits='userSpaceOnUse'
          height='70'
          id='filter0_d_270_71'
          width={dimensions.width}
          x='0'
          y='0'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix
            in='SourceAlpha'
            result='hardAlpha'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          ></feColorMatrix>
          <feOffset dy='2'></feOffset>
          <feGaussianBlur stdDeviation='1.5'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'></feColorMatrix>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_270_71'></feBlend>
          <feBlend in='SourceGraphic' in2='effect1_dropShadow_270_71' result='shape'></feBlend>
        </filter>
      </defs>
    </svg>
  );
}
